import React from 'react';
export function Footer() {
  return <footer className="bg-black text-white py-12 border-t border-gray-900" data-id="element-85">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-87">
          <div className="mb-6 md:mb-0 text-center md:text-left" data-id="element-88">
            <img src="https://cdn.magicpatterns.com/uploads/mNrYvD2wkbgP3UZCXBCWR5/Asset_12300x_(1).png" alt="Blazing Barry's Coffee Icon" className="h-10 w-auto mx-auto md:mx-0 mb-4" data-id="element-89" />
            <p className="text-gray-500 text-sm" data-id="element-90">
              &copy; {new Date().getFullYear()} Blazing Barry's Coffee.
              <br data-id="element-91" />
              All rights reserved.
            </p>
          </div>

          <div className="flex space-x-6 md:space-x-8" data-id="element-92">
            <a href="#home" className="text-gray-400 hover:text-brand-red transition-colors text-sm uppercase tracking-wider" data-id="element-93">
              Home
            </a>
            <a href="#about" className="text-gray-400 hover:text-brand-red transition-colors text-sm uppercase tracking-wider" data-id="element-94">
              About
            </a>
            <a href="#varieties" className="text-gray-400 hover:text-brand-red transition-colors text-sm uppercase tracking-wider" data-id="element-95">
              Varieties
            </a>
            <a href="#contact" className="text-gray-400 hover:text-brand-red transition-colors text-sm uppercase tracking-wider" data-id="element-96">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>;
}